import type { FC } from 'react';
import { useTheme } from 'styled-components';
import { useGetCommonStore } from '@/store';
import { Spinner } from '@/styles/common';
import { BonusList } from './components/BonusList';
import { CompointsBanner } from './components/CompointsBanner';
import { EmptyState } from './components/EmptyState';
import { useActiveBonuses } from './hooks/useActiveBonuses';
import { ScActiveBonuses } from './styled';

export const ActiveBonuses: FC = () => {
  const { mainColor, blackColor } = useTheme();
  const useCommonStore = useGetCommonStore();

  const freespinsPending = useCommonStore.use.freespinsPending();
  const bonusesPending = useCommonStore.use.bonusesPending();

  const activeBonuses = useActiveBonuses();
  const hasBonuses = activeBonuses.length > 0;

  if (bonusesPending || freespinsPending) {
    return (
      <Spinner background={blackColor} center color={mainColor} size={60} />
    );
  }

  return (
    <ScActiveBonuses>
      {hasBonuses ? <BonusList bonuses={activeBonuses} /> : <EmptyState />}
      <CompointsBanner />
    </ScActiveBonuses>
  );
};
